import { RootState } from "../types";

export const refreshTokenSelector = (state: RootState) =>
  state.user.refreshToken;
export const isAuthSelector = (state: RootState) => state.user.isAuth;
export const errorUserSelector = (state: RootState) => state.user.error;
export const errorTimeStampSelector = (state: RootState) => state.user.retryAfterTimestamp;
export const isChargingCustomersSelector = (state: RootState) => 
  state.user.isChargingCustomers ?? false;
export const therapistsCanSeePricesSelector = (state: RootState) => 
  state.user.therapistsCanSeePrices ?? false;
export const canAddDefaultReportsSelector = (state: RootState) =>
  state.user.canAddDefaultReports ?? false;
export const adminCanViewPatientRecordingsSelector = (state: RootState) =>
  state.user.adminCanViewPatientRecordings ?? false;
/** Company works with devices: adds the "by device" column mode to the appointments board. */
export const deviceViewEnabledSelector = (state: RootState) =>
  state.user.deviceViewEnabled ?? false;
export const showUnauthorizedModalSelector = (state: RootState) => 
  state.user.showUnauthorizedModal ?? false;
export const companyGuidSelector = (state: RootState) => 
  state.user.companyGuid ?? null;
export const companyIdSelector = (state: RootState) =>
  state.user.admin.companyId ?? null;